export default {
    namespaced: true,
    state: {
        client: ""
    },

    getters: {
        getClient: (state) => {
            return state.client;
        }
    },

    mutations: {
        SET_CLIENT: (state, payload) => {
            state.client = payload.result
        },
    },

    actions: {
        get: async ({commit, rootState}, rfc) => {
            let {data} = await  rootState.init.http_common.get('/clientes/'+rfc);
            commit('SET_CLIENT', data)
        },

        validateRfc: async ({rootState}, rfc) => {
            await  rootState.init.http_common.get('/validarrfc/' + rfc);
        },

    }

}